import { tryCatch, wsClient } from './client';

/**
 * 回傳貨幣比較資訊
價格　　：200026
漲跌幅　：200044
漲跌方向：200025
 * @param currencies
 * @returns
 */
export const GETv1CurrenciesComparison = (currencies: string) => {
  return tryCatch(async () => {
    const url = `/ws/api/v1/forex/currency/comparison/${currencies}`;

    const data = await wsClient.get(url);

    return data;
  });
};
